const PaidHitClubFilters = () => {
    return null;
};

export default PaidHitClubFilters;
